export default "__VITE_ASSET__BZSDX5dO__"